import type { QueryResult } from "src/types/adapters/query.type";
import {
  ResultsContent,
  SearchResultContentContainer,
} from "../SearchResults.styled";
import { SuggestionList } from "./SuggestionList";
import { ProductSuggestionList } from "./ProductSuggestionList";

type SearchResultContentProps = {
  results?: QueryResult;
};

function SearchResultContent({ results }: SearchResultContentProps) {
  if (!results) {
    return null;
  }

  return (
    <SearchResultContentContainer>
      <ResultsContent>
        {results.suggestions && results.suggestions.length ? (
          <SuggestionList suggestions={results.suggestions} />
        ) : null}
        {results.products && results.products.length ? (
          <ProductSuggestionList
            products={results.products}
            total={results.totalProductsResult}
            query={results.query}
          />
        ) : null}
      </ResultsContent>
    </SearchResultContentContainer>
  );
}

export { SearchResultContent };
